import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const Footer = () => {
  return (
    <footer className="border-t border-[#E4DFD2] bg-[#FBFAF6]" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-10">
          <div className="col-span-2">
            <Logo size={24} />
            <p className="text-sm text-[#69747C] mt-4 max-w-sm leading-relaxed">
              Retainer Tracker is a simple client retainer tracking app for consultants, studios, and small agencies.
              Track hours, cost, profit, margin, and client status.
            </p>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.1em] uppercase font-semibold text-[#1F2326] mb-3">
              Product
            </div>
            <ul className="space-y-2 text-sm text-[#69747C]">
              <li><Link to="/pricing" className="hover:text-[#1F2326]" data-testid="footer-pricing-link">Pricing</Link></li>
              <li><Link to="/what-is-retainertracker" className="hover:text-[#1F2326]">What is Retainer Tracker</Link></li>
              <li><Link to="/why-retainertracker" className="hover:text-[#1F2326]">Founder story</Link></li>
              <li><Link to="/faqs" className="hover:text-[#1F2326]">FAQs</Link></li>
              <li><Link to="/help" className="hover:text-[#1F2326]">Help center</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.1em] uppercase font-semibold text-[#1F2326] mb-3">
              Use cases
            </div>
            <ul className="space-y-2 text-sm text-[#69747C]">
              <li><Link to="/client-retainer-tracker" className="hover:text-[#1F2326]">Client retainer tracker</Link></li>
              <li><Link to="/retainer-tracking-software" className="hover:text-[#1F2326]">Retainer tracking software</Link></li>
              <li><Link to="/simple-client-tracking-app" className="hover:text-[#1F2326]">Simple client tracking app</Link></li>
              <li><Link to="/simple-customer-tracking-app" className="hover:text-[#1F2326]">Simple customer tracking app</Link></li>
              <li><Link to="/retainer-profitability-dashboard" className="hover:text-[#1F2326]">Profitability dashboard</Link></li>
              <li><Link to="/retainer-tracking-spreadsheet-alternative" className="hover:text-[#1F2326]">Spreadsheet alternative</Link></li>
              <li><Link to="/how-to-track-retainer-hours" className="hover:text-[#1F2326]">How to track retainer hours</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.1em] uppercase font-semibold text-[#1F2326] mb-3">
              Legal &amp; contact
            </div>
            <ul className="space-y-2 text-sm text-[#69747C]">
              <li><Link to="/privacy" className="hover:text-[#1F2326]" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#1F2326]" data-testid="footer-terms-link">Terms of Use</Link></li>
              <li><Link to="/contact" className="hover:text-[#1F2326]" data-testid="footer-contact-link">Contact</Link></li>
              <li>
                <a
                  href="mailto:support@retainertracker.com"
                  className="hover:text-[#1F2326]"
                  data-testid="footer-support-email"
                >
                  support@retainertracker.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 pt-6 border-t border-[#E4DFD2] text-xs text-[#69747C]">
          <div>© {new Date().getFullYear()} Retainer Tracker. All rights reserved.</div>
          <div className="flex gap-5">
            <a
              href="mailto:hello@retainertracker.com"
              className="hover:text-[#1F2326]"
              data-testid="footer-hello-email"
            >
              hello@retainertracker.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
